<template>
	<div class="wrapper">
		<headerTag />
			<div class="userCon userCon1 clear" style="margin-top: 4.73rem;">
				<img src="../../assets/images/user/touxiang.png" alt="" />
				<p>
					<router-link :to="{ name:'baseMessage' }">
						<span>{{username}}</span>
						<span>查看并编辑个人资料</span>
					</router-link>
				</p>
			</div>
			<ul class="userCon userCon2 clear">
				<li @click="toMustLogin('/order/orderInfo')">
					<span v-if="orderCount > 99">99+</span>
					<span v-else>{{orderCount}}</span>
					<span>订单</span>
				</li>
				<li @click="toMustLogin('/problem/mineTiwen')">
					<span v-if="askCount > 99">99+</span>
					<span v-else>{{askCount}}</span>
					<span>提问</span>
				</li>
				<li @click="toMustLogin('/problem/tousu')">
					<span v-if="complaintCount > 99">99+</span>
					<span v-else>{{complaintCount}}</span>
					<span>投诉</span>
				</li>
			</ul>
			<div class="userCon userCon3 clear">
					<p @click="toMustLogin('/order/orderInfo')">
						<img src="../../assets/images/user/user_icon1.png" alt="" />
						我的订单
					</p>
					<p @click="toMustLogin('/problem/mineTiwen')">
						<img src="../../assets/images/user/user_icon2.png" alt="" />
						我的提问
					</p>
					<p @click="toMustLogin('/problem/tousu')">
						<img src="../../assets/images/user/user_icon3.png" alt="" />
						我的投诉
					</p>
			</div>
			<button class="userBtn1" @click="loginout">退出登录</button>
		<footerTag />
	</div>
</template>
<script>
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'

	export default {
		name: 'userIndex',
		props: {
        
		},
		data(){
		  return {
				username:'',
				askCount:'0',
				complaintCount:'0',
				orderCount:'0'
		  }
		},
		methods:{
			toMustLogin(page){
				this.axios({
				    method: 'POST',
				    url:'/user/getUserName',
				}).then((res)=>{
						if(res.data.obj != null && res.data.obj != ''){
							// 用户已登录
							window.location.href=page;
						}else{
							//未登录
							window.location.href='/login?targetUrl='+page;
						}
				}).catch((err)=>{
					this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			loadUserIndex() {
				this.axios({
				    method: 'POST',
				    url:'/user/userHome',
				}).then((res)=>{
						if(res.data.code==1000){
							 let resultData = res.data.data;
							 this.username = resultData.userName;
							 this.askCount = resultData.askCount;
							 this.complaintCount = resultData.complaintCount;
							 this.orderCount = resultData.orderCount;
						}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
				  		}else{
				  			this.$message.error({message: res.data.message});
				  		}
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			},
			// 退出登录
			loginout(){
				this.axios({
				    method: 'GET',
				    url:'/user/loginout',
				}).then((res)=>{
						if(res.data.code==1000){
							 this.$router.push({ name:'homePage' });
						}
				}).catch((err)=>{
				    this.$message.error({message: '网络异常，请稍后重试'});
				})
			}
		},
		components: {
			headerTag,
			footerTag
		},
		created(){
			this.loadUserIndex();
		}
	}

</script>